import React, { useState, useEffect, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import * as faceapi from 'face-api.js';
import '../../assets/css/register.css';

const Register = () => {
    const [formData, setFormData] = useState({
        empCode: '',
        name: '',
        category: '',
        email: '',
        phoneNumber: '',
        emergencyNumber: '',
        aadhar: '',
        panCard: '',
        password: '',
        divCode: 'KOL',
        projectCode: '',
        subContractor: '',
        fathersName: '',
        dob: '',
        role: ''
    });

    const [message, setMessage] = useState('');
    const [faceDescriptors, setFaceDescriptors] = useState(null);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const token = localStorage.getItem('token');
    let decoded = {};

    if (token) {
        try {
            decoded = jwtDecode(token);
        } catch (err) {
            console.error('Invalid token', err);
        }
    }

    useEffect(() => {
        const loadModels = async () => {
            try {
                const MODEL_URL = '/models/';
                await Promise.all([
                    faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
                    faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
                    faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL)
                ]);
                startVideoStream();
            } catch (error) {
                console.error('Error loading face-api models:', error);
            }
        };

        loadModels();
    }, []);

    const startVideoStream = () => {
        navigator.mediaDevices.getUserMedia({ video: {} })
            .then(stream => {
                videoRef.current.srcObject = stream;
            })
            .catch(err => {
                console.error('Error accessing the camera', err);
            });
    };

    const captureFace = async () => {
        if (!videoRef.current) return;

        let retries = 0;
        const maxRetries = 5;
        const minBoxWidth = 100;

        const dims = faceapi.matchDimensions(canvasRef.current, videoRef.current, true);
        const detect = async () => {
            const result = await faceapi.detectSingleFace(videoRef.current, new faceapi.TinyFaceDetectorOptions({ inputSize: 416, scoreThreshold: 0.5 }))
                .withFaceLandmarks()
                .withFaceDescriptor();

            if (result) {
                const resized = faceapi.resizeResults(result, dims);
                const boxWidth = resized.detection.box.width;

                if (boxWidth < minBoxWidth) {
                    retries++;
                    return false;
                }

                setFaceDescriptors(result.descriptor);
                alert('✅ Face captured successfully!');
                return true;
            }

            return false;
        };

        while (retries < maxRetries) {
            const detected = await detect();
            if (detected) break;
            retries++;
            await new Promise(resolve => setTimeout(resolve, 500));
        }

        if (retries >= maxRetries) {
            alert('❌ Face not detected. Please ensure lighting and alignment.');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'empCode') {
            const isEmployee = formData.category === 'Employee';
            const maxLength = isEmployee ? 6 : 5;
            if (!/^\d*$/.test(value) || value.length > maxLength) return;
        }
        setFormData(prev => ({
        ...prev,
        [name]: value 
        // ✅ Removed the hardcoded divCode
    }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { category, empCode, phoneNumber, emergencyNumber, aadhar, panCard, dob } = formData;

        if (category === 'Employee' && empCode.length !== 6) {
            alert('Employee empCode must be exactly 6 digits.');
            return;
        }

        if (!/^[0-9]{10}$/.test(phoneNumber)) {
            alert('Phone Number must be exactly 10 digits');
            return;
        }

        if (!/^[0-9]{10}$/.test(emergencyNumber)) {
            alert('Emergency Number must be exactly 10 digits');
            return;
        }

        if (!/^[0-9]{12}$/.test(aadhar)) {
            alert('Aadhar Number must be exactly 12 digits');
            return;
        }

        if (panCard && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panCard)) {
            alert('PAN Card must be in correct format (e.g., ABCDE1234F)');
            return;
        }

        if (!faceDescriptors) {
            alert('Please capture your face first!');
            return;
        }

        try {
            const response = await axios.post(
                'https://gannondunkerley.in/employees/sync-employees',
                {
                    logs: [{
                        ...formData,
                        dob: new Date(formData.dob).toISOString(),
                        faceDescriptors
                    }]
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            alert('Registration successful.');
            setFaceDescriptors(null);
            setMessage(response.data.message);
        } catch (error) {
            if (error.response?.status === 409) {
                setMessage(`Employee with empCode ${empCode} already exists.`);
            } else {
                setMessage('Registration failed. Please try again.');
            }
            console.error(error);
        }
    };

    return (
        <div className="content">
            <div className="register-container">
                <h1 style={{ color: '#1a73e8' }}>Employee Registration</h1>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Category:</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Category</option>
                            <option value="Employee">Employee</option>
                            <option value="MR Staff">MR Staff</option>
                            <option value="Labour">Labour</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>EmpCode / Aadhar Card (Last 5):</label>
                        <input
                            type="text"
                            name="empCode"
                            value={formData.empCode}
                            onChange={handleChange}
                            maxLength={6}
                            disabled={formData.category !== 'Employee'}
                            required
                        />
                    </div>


                    <div className="form-group">
                        <label>Name:</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Father's Name:</label>
                        <input
                            type="text"
                            name="fathersName"
                            value={formData.fathersName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Email/Phone:</label>
                        <input
                            type="text"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Date of Birth</label>
                        <input type="date" name="dob" value={formData.dob} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>Phone Number:</label>
                        <input type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>Emergency Number:</label>
                        <input type="text" name="emergencyNumber" value={formData.emergencyNumber} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>Aadhar:</label>
                        <input type="text" name="aadhar" value={formData.aadhar} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>PAN Card:</label>
                        <input type="text" name="panCard" value={formData.panCard} onChange={handleChange} />
                    </div>

                    <div className="form-group">
    <label>Division:</label>
    <input
        type="text"
        name="divCode"
        value="KOL" // ❌ BOHOT BADA BUG! Yeh hamesha "KOL" string dikhayega, par state me store nahi karega!
        onChange={handleChange}
        required
        disabled={decoded.role === "admin"}
    />
</div>
                    {formData.category === "Labour" && (
                        <div className="form-group">
                            <label>Sub Contractor:</label>
                            <input
                                type="text"
                                name="subContractor"
                                value={formData.subContractor}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label>Project:</label>
                            <input
                                type="text"
                                name="projectCode"
                                value={formData.projectCode}
                                onChange={handleChange}
                                required
                            />
                    </div>

                    <div className="form-group">
                        <label>Role:</label>
                        {decoded.role === "powerUser" && (
                            <select
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Role</option>
                                <option value="User">User</option>
                                <option value="admin">Admin</option>
                                <option value="powerUser">Power User</option>
                            </select>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Capture Face:</label>
                        <div style={{ position: 'relative' }}>
                            <video ref={videoRef} autoPlay muted style={{ width: '100%' }} />
                            <canvas ref={canvasRef} style={{ position: 'absolute', top: 0, left: 0 }} />
                        </div>
                        <button type="button" onClick={captureFace}>
                            {faceDescriptors ? "✅ Face Captured" : "📸 Capture Face"}
                        </button>
                    </div>
                    <button type="submit">Register</button>
                </form>
                {message && <p>{message}</p>}
            </div>
        </div>
    );
};

export default Register;
